import { Link } from "react-router-dom";
import { Table, Tag, Tooltip, Collapse } from "antd";
import moment from "moment";
import React, { useState } from "react";
import InvoiceModal from "./invoice-modal";

const { Panel } = Collapse;

const InvoicesTable = ({ onChange, loading, meta, invoices, hideUtm }) => {
    const [selectedInvoice, setSelectedInvoice] = useState(null); // State to track selected invoice
    const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility

    const handleInvoiceClick = (invoice) => {
        setSelectedInvoice(invoice);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedInvoice(null);
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 0:
                return <Tag>Pending</Tag>;
            case 1:
                return <Tag color="green">Paid</Tag>;
            case 2:
                return <Tag color="green">Recurring Active</Tag>;
            case 3:
                return <Tag color="red">Recurring Cancelled</Tag>;
            case 4:
                return <Tag color="red">Recurring Failed</Tag>;
            case 5:
                return <Tag>Recurring Finished</Tag>;
            case 7:
                return <Tag>Chargeback</Tag>;
            case 8:
                return <Tag>Not confirmed</Tag>;
            default:
                return 'Unknown';
        }
    };

    return (
        <div>
            <Table
                rowKey="invoice_id" // Or any other unique field in your data
                style={{ width: "100%" }}
                size="small"
                loading={loading}
                onChange={onChange}
                scroll={{ x: 500 }}
                pagination={meta ? { pageSize: 20, total: meta.total, current: meta.current_page } : false}
                dataSource={invoices}
                columns={[
                    {
                        title: 'invoice_id',
                        dataIndex: 'invoice_id',
                        key: 'invoice_id',
                        render: (value, record) => (
                            <a onClick={() => handleInvoiceClick(record)}>{value}</a>
                        ),
                    },
                    {
                        title: 'user_id',
                        dataIndex: 'user_id',
                        key: 'user_id',
                        render: (value, record) => (
                            <Link to={'/user/' + value}>{value}</Link>
                        ),
                    },
                    !hideUtm && {
                        title: 'Title',
                        dataIndex: 'items',
                        key: 'item_title',
                        render: (items) => {
                            if (!Array.isArray(items) || items.length === 0) {
                                return <span>N/A</span>;
                            }

                            return <span>{items[0].item_title}</span>;
                        },
                    },
                    !hideUtm && {
                        title: 'Product ID',
                        dataIndex: 'items',
                        key: 'billing_plan_id',
                        render: (items) => {
                            if (!Array.isArray(items) || items.length === 0) {
                                return <Tag>N/A</Tag>;
                            }

                            return <Tag>{items[0].billing_plan_id}</Tag>;
                        },
                    },
                    {
                        title: 'first_period',
                        dataIndex: 'first_period',
                        key: 'first_period',
                    },
                    {
                        title: 'first_total',
                        dataIndex: 'first_total',
                        key: 'first_total',
                        render: (value, record) => <span>{value} {record.currency}</span>,
                    },
                    !hideUtm && {
                        title: 'coupon_code',
                        dataIndex: 'coupon_code',
                        key: 'coupon_code',
                        render: (value, record) => value ? <Tag color="orange">{value}</Tag> : "",
                    },
                    !hideUtm && {
                        title: 'paysys_id',
                        dataIndex: 'paysys_id',
                        key: 'paysys_id',
                    },
                    {
                        title: 'tm_added',
                        dataIndex: 'tm_added',
                        key: 'tm_added',
                        render: value => {
                            const formattedDate = moment(value).locale('et').format('YYYY-MM-DD');
                            const formattedTime = moment(value).locale('et').format('HH:mm:ss');
                            return (
                                <>
                                    <Tag style={{fontSize: 12}}>{formattedDate} {formattedTime}</Tag>
                                </>
                            );
                        },
                    },
                    {
                        title: 'status',
                        dataIndex: 'status',
                        key: 'status',
                        render: status => getStatusLabel(status),
                    },
                ].filter(Boolean)} // Filters out any `false` or `undefined` columns

                expandable={{
                    expandedRowRender: (record) => (
                        <Collapse defaultActiveKey={1} style={{ margin: 0 }}>
                            <Panel header="UTM Details" key={1}>
                                <div>
                                    {record.utm_campaign && (
                                        <p><strong>UTM Campaign:</strong> {record.utm_campaign}</p>
                                    )}
                                    {record.utm_medium && (
                                        <p><strong>UTM Medium:</strong> {record.utm_medium}</p>
                                    )}
                                    {record.utm_source && (
                                        <p><strong>UTM Source:</strong> {record.utm_source}</p>
                                    )}
                                    {record.utm_term && (
                                        <p><strong>UTM Term:</strong> {record.utm_term}</p>
                                    )}
                                    {record.gclid && (
                                        <p><strong>GCLID:</strong> {record.gclid}</p>
                                    )}
                                </div>
                            </Panel>
                        </Collapse>
                    ),
                    rowExpandable: (record) => !!record.utm_campaign || !!record.gclid, // Only show expand option if UTM data exists
                }}
            />

            <InvoiceModal isModalVisible={isModalVisible} selectedInvoice={selectedInvoice} handleModalClose={handleModalClose} />
        </div>
    );
};

export default InvoicesTable;
